import { createFSMReducer } from 'app-webtech-core/reducers/fsm';
import { combineReducers } from 'redux';
import { viralIsEnabledReducer } from './isEnabled';
import { FETCH_ALL } from '../actions/types';
import {
  viralFetchAllFailureReducer,
  viralFetchAllRequestReducer,
  viralFetchAllSuccessReducer,
} from './fetchViralClips';
import { VIRAL_CONTENT_STATE_STATUSES } from '../constants';

const defaultState = {
  clips: [],
  status: VIRAL_CONTENT_STATE_STATUSES.EMPTY,
  error: null,
};

const params = {
  initial: VIRAL_CONTENT_STATE_STATUSES.EMPTY,
  actionReducers: {
    [FETCH_ALL.REQUEST]: {
      reducer: viralFetchAllRequestReducer,
    },
    [FETCH_ALL.SUCCESS]: {
      reducer: viralFetchAllSuccessReducer,
      next: VIRAL_CONTENT_STATE_STATUSES.DONE,
    },
    [FETCH_ALL.FAILURE]: {
      reducer: viralFetchAllFailureReducer,
      next: VIRAL_CONTENT_STATE_STATUSES.ERROR,
    },
  },
  states: {
    [VIRAL_CONTENT_STATE_STATUSES.EMPTY]: {
      accepts: '*',
    },
    [VIRAL_CONTENT_STATE_STATUSES.PENDING]: {
      accepts: '*',
    },
    [VIRAL_CONTENT_STATE_STATUSES.DONE]: {
      accepts: '*',
    },
    [VIRAL_CONTENT_STATE_STATUSES.ERROR]: {
      accepts: '*',
    },
  },
};

const viralContent = createFSMReducer(defaultState, params);

export const viralReducer = combineReducers({
  content: viralContent,
  isEnabled: viralIsEnabledReducer,
});
